/**
 * region for libraries*/
 import React, { Component } from "react";
 import PropTypes from "prop-types";
 import { withStyles } from "@material-ui/core/styles";
 import Table from "@material-ui/core/Table";
 import TableBody from "@material-ui/core/TableBody";
 import TableCell from "@material-ui/core/TableCell";
 import TableContainer from "@material-ui/core/TableContainer";
 import TableRow from "@material-ui/core/TableRow";
 import Paper from "@material-ui/core/Paper";
 import TableHead from "@material-ui/core/TableHead";
 import TableSortLabel from "@material-ui/core/TableSortLabel";
 import TablePagination from "@material-ui/core/TablePagination"; 
 import Link from "@material-ui/core/Link";
 
 /**
  * region for redux*/
 import { connect } from "react-redux";
 import { BrokenUrlResultActions } from "../../actions/BrokenUrlResultActions";
 /**
  * region for styles*/
 import { reportBrokenUrlsStyle } from "./style/reportBrokenUrlsStyle";
 /**
  * region for componets*/
 import TextResponse from "../../components/common/TextResponse";

 import ajax from '../../helpers/ajax';
 /**
  * region for constans*/
  import Constants from '../../constants/Constants'
 
 class ReportBrokenUrls extends Component {
   state = {
     rowsPerPage: 25,
     order: "asc",
     orderBy: "companyId",
     anchorEl: null,
     backofficeUrlBase:"",
     newBackofficeUrlBase: "",
     newBackofficeUrlApiBase: "",
     newBackOfficeTokenValid:false
   };
 
   componentDidMount() {
     this.load();
   }

   load() {
    const self = this;

    ajax.get(Constants.ROUTE_API_COMMONDATA,
        {
            success: function (response) {
                self.setState(
                    {
                        backofficeUrlBase: response.data.urlBackofficeBase,
                        newBackofficeUrlBase: response.data.urlNewBackofficeBase,
                        newBackofficeUrlApiBase : response.data.urlNewBackofficeApiBase
                    },
                    () => {
                        self.props.fetchGetList();
                        self.validateTokenNewBo();
                    }
                );
            }
        });
  }

  validateTokenNewBo() {
    const self = this;
    let urlParams = new URLSearchParams(document.location.search);
    let newBackOfficeToken = urlParams.get('BackOfficeToken');
    
    if (newBackOfficeToken !== null && newBackOfficeToken !== ""){
        fetch(`${self.state.newBackofficeUrlApiBase}/users?token=${newBackOfficeToken}`)
        .then((result) => {
            if (result.status === 200){
            self.setState({newBackOfficeTokenValid: true});
            }
        });
    }
  };
 
   handleChangeRowsPerPage = (event) => {
     this.setState({ rowsPerPage: parseInt(event.target.value, 10)},this.props.setPageListFilter(0));
   };
 
   handleChangePage = (event, newPage) => {
    this.props.setPageListFilter(newPage);
   };
 
   handleRequestSort = (event, property) => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      this.setState({ order: isAsc ? 'desc' : 'asc',orderBy: property});
   };

   handleOnApprove = (event, IdFreeprofilesUrl) => {
    let listResult = this.props.ListResult;
    let originalList = this.props.OriginalList;

    this.props.fetchApprove(IdFreeprofilesUrl, listResult, originalList);
   };
 
   stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
       const order = comparator(a[0], b[0]);
       if (order !== 0) return order;
       return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
   }
 
   getComparator(order, orderBy) {
     return order === 'desc'
       ? (a, b) => this.descendingComparator(a, b, orderBy)
       : (a, b) => -this.descendingComparator(a, b, orderBy);
   }
 
   descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
       return -1;
     }
     if (b[orderBy] > a[orderBy]) {
       return 1;
     }
     return 0;
   }
 
   headerTableRow() {
     return [
       { id: "IdFreeprofile", numeric: false, disablePadding: true, label: "Company ID", minWidth:110, maxWidth:110, width:'auto'},
       { id: "Company", numeric: false, disablePadding: false, label: "Company Name", minWidth:350, maxWidth:350, width:350},
       { id: "Url", numeric: false, disablePadding: false, label: "URL", minWidth:400 , maxWidth:400, width:400},
       { id: "StatusString", numeric: false, disablePadding: false, label: "Status", minWidth:150, maxWidth:200, width:'auto'},       
       { id: "Approve", numeric: false, disablePadding: false, label: "", minWidth:150, maxWidth:200, width:'auto'},       
     ];
   }
 //
   render() {
     let self = this;
     //#region init date redux
     const { classes, ListResult } = this.props;
     //#endregion

     //#region changing data state componet
     let page = self.props.page;
     let rowsPerPage = self.state.rowsPerPage;
     let order = self.state.order;
     let orderBy = self.state.orderBy;
     let tableRows, tableHeader;
     let tableTotalRows = Object.keys(ListResult).length > 0 ? ListResult.data.length : 0;
     let emptyRows = rowsPerPage - Math.min(rowsPerPage, tableTotalRows - page * rowsPerPage);
     //#endregion
 
     tableHeader = (
       <TableHead>
         <TableRow>
           {self.headerTableRow().map((headCell) => (
             <TableCell component="th" scope="row" width={headCell.width} style={{ minWidth: headCell.minWidth, maxWidth:headCell.maxWidth}}
               key={headCell.id}
               align={headCell.numeric ? "right" : "left"}
               padding={headCell.disablePadding ? "none" : "default"}
               sortDirection={orderBy === headCell.id ? order : false}>   
              { headCell.id !== "Approve" && (
               <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : "asc"} onClick={(event) => self.handleRequestSort(event, headCell.id)}>
                 {headCell.label}
                 {orderBy === headCell.id ? <span className={classes.visuallyHidden}>{order === "desc" ? "sorted descending" : "sorted ascending"}</span> : null}
               </TableSortLabel>)
               }
             </TableCell>
           ))}
         </TableRow>
       </TableHead>
     );
 
     if (Object.keys(ListResult).length > 0) {
       tableRows = self.stableSort(ListResult.data, self.getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {
        const linkCompany = self.state.newBackOfficeTokenValid ?
            `${self.state.newBackofficeUrlBase}/companies/${item.IdFreeprofile}` :
            `${self.state.backofficeUrlBase}/File_Contactmoment.asp?code=${item.IdFreeprofile}`;
        const targetLinkCompany = self.state.newBackOfficeTokenValid ? "_blank" : "";
        const companyNameCapitalized = item.Company.charAt(0).toUpperCase() + item.Company.slice(1);
         return (
           <TableRow key={index} hover> 
             <TableCell align="left"><Link href={linkCompany}  rel="noopener" target={targetLinkCompany}>{item.IdFreeprofile}</Link></TableCell>             
             <TableCell align="left"><div style={{overflow:'hidden', whiteSpace:'nowrap',width: '350px' ,textOverflow:'ellipsis' }}><Link href={linkCompany}  rel="noopener" target={targetLinkCompany}>  <span>{companyNameCapitalized}</span></Link></div></TableCell>
             <TableCell align="left"><div style={{overflow:'hidden', whiteSpace:'nowrap',width: '400px' ,textOverflow:'ellipsis' }}><Link href={item.Url} target="_blank" rel="noopener">{item.Url}</Link></div> </TableCell>
             <TableCell align="left">{item.StatusString}</TableCell>
             <TableCell align="left">
                <a href="#/" className={classes.approve} onClick={(event) => self.handleOnApprove(event, item.IdFreeprofilesUrl)}>
                  <i className="fas fa-check-circle font-size-md"/><span className="ml-1 text-center">Approve</span>
                </a>
              </TableCell>
           </TableRow>//className={approveButtonClass} 
         );
       });
     }
 
     return (
       <div className={classes.root}>
         <Paper className={classes.paper}>
           
           <TableContainer component={Paper}>
             <Table className={classes.table} size={"small"} aria-label="caption table">
               {tableHeader}
               {tableTotalRows > 0 && (
                 <TableBody>
                   {tableRows}
                   {emptyRows > 0 && (
                     <TableRow style={{ height: 31 * emptyRows }}>
                       <TableCell colSpan={6} />
                     </TableRow>
                   )}
                 </TableBody>
               )}
               {tableTotalRows === 0 && !this.props.pending && (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={6}>
                        <TextResponse text="Sorry, no matching records found" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
               )}
             </Table>
           </TableContainer>
           <TablePagination
             rowsPerPageOptions={[5, 10, 25]}
             component="div"
             count={tableTotalRows}
             rowsPerPage={rowsPerPage}
             page={page}
             onChangePage={self.handleChangePage}
             onChangeRowsPerPage={self.handleChangeRowsPerPage}
           />
         </Paper>
       </div>
     );
   }
 }
 ReportBrokenUrls.propTypes = {
   classes: PropTypes.object.isRequired,
 };
 
 function mapStateToProps(state) {
   const ListResult = state.BrokenUrlResultReducers.ListResult;
   const OriginalList = state.BrokenUrlResultReducers.OriginalList;
   const pending = state.BrokenUrlResultReducers.pending;
   const page = state.BrokenUrlResultReducers.page;

   return {
     ListResult,
     OriginalList,
     pending,
     page 
   };
 }
 
 const mapDispatchToProps = (dispatch) => {
   return {
     fetchGetList: () => dispatch(BrokenUrlResultActions.fetchGetList()),
     setPageListFilter: (page) => dispatch(BrokenUrlResultActions.setPageListFilter(page)),
     fetchApprove: (idfreeprofilesurl,ListResult, OriginalList) => dispatch(BrokenUrlResultActions.fetchApprove(idfreeprofilesurl,ListResult, OriginalList))
   };
 };
 export default connect(mapStateToProps, mapDispatchToProps)(withStyles(reportBrokenUrlsStyle)(ReportBrokenUrls));
 